import React from 'react';
import moment from 'moment';
import sniffer from 'sniffer';
import packageJson from './../../../package.json';
import FooterMenu from './Menu';
var Footer = function Footer() {
  return /*#__PURE__*/React.createElement("div", null, sniffer.isDesktop || sniffer.isTablet ? /*#__PURE__*/React.createElement("div", {
    className: "site-footer footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer-content"
  }, "Haldor - ", moment().format('YYYY'), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '0.35em'
    }
  }, "Release ", packageJson.version))) : null, /*#__PURE__*/React.createElement(FooterMenu, null));
};
export default Footer;